import type { Formatter } from '../types';

/**
 * Console-friendly formatter: a severity tag, the log key, the message, and
 * the context object left unstringified so devtools renders it inspectable.
 *
 * The key is part of the line, not decoration: `makeNamespacedLog('x')` is what
 * makes `pm2 logs botman | grep x` work, and the support runbooks are written
 * against that.
 *
 * It reaches a terminal more often than a browser, despite the name. A Node
 * service picks its formatter through `detect-browser`, whose `detect()`
 * returns `null` under Node rather than `{ name: 'node' }`, so every
 * non-production Node process lands here rather than on the stdout formatter.
 *
 * Context is omitted from the returned array when absent, because `log()`
 * spreads it into `console.log` and a present-but-undefined second element
 * prints a trailing `undefined` on every context-free call.
 */
export const formatter: Formatter = (
  severity: string,
  key: string,
  message: string,
  context: any,
) => {
  const line = `[${severity}] [${key}] ${message}`;

  return context === undefined ? [line] : [line, context];
};
